document.addEventListener("DOMContentLoaded", () => {
 let quickAddDrawer = document.querySelector('main-cart')
    if (quickAddDrawer) {   
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    BSS_B2B.observer.cartSubject.listenCartCheckout() 
                }
            });
        });
        observer.observe(quickAddDrawer, {childList: true});
    }
});



function splitPrice(el) {
  if (el.querySelector(".bss-price")) return;

  const text = el.textContent.trim();
  const match = text.match(/^([^\s]+)\s+(.+)$/);
  if (!match) return;

  const [, price, excl] = match;

  el.innerHTML = `
    <span class="bss-price">${price}</span>
    <span class="bss-excl">${excl}</span>
  `;
}

function initPriceSplit() {
  document.querySelectorAll(".bss-b2b-price-no-vat").forEach(splitPrice);
}

initPriceSplit();

const observer = new MutationObserver(() => {
  initPriceSplit();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true
});
